/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type CorporatePage_viewer$ref = any;
export type CorporatePage_QueryVariables = {};
export type CorporatePage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": CorporatePage_viewer$ref;
    }) | null;
};
export type CorporatePage_Query = {
    readonly response: CorporatePage_QueryResponse;
    readonly variables: CorporatePage_QueryVariables;
};



/*
query CorporatePage_Query {
  viewer {
    id
    ...CorporatePage_viewer
  }
}

fragment CorporatePage_viewer on Viewer {
  user {
    id
    userId
    email
    useAccountCheckout
    cart {
      id
      viaQualifiedCartTotal
    }
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
      }
    }
    shoppingWithCeoUser {
      id
      firstName
      lastName
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CorporatePage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "CorporatePage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CorporatePage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "userId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "useAccountCheckout",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "viaQualifiedCartTotal",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "access",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "firstName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "lastName",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "CorporatePage_Query",
            "id": null,
            "text": "query CorporatePage_Query {\n  viewer {\n    id\n    ...CorporatePage_viewer\n  }\n}\n\nfragment CorporatePage_viewer on Viewer {\n  user {\n    id\n    userId\n    email\n    useAccountCheckout\n    cart {\n      id\n      viaQualifiedCartTotal\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n      }\n    }\n    shoppingWithCeoUser {\n      id\n      firstName\n      lastName\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '028c6f1f468a14b40e24808ea4363e22';
export default node;
